import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";

import MSDemoLayout from "./layout/MSDemoLayout";
import BaseDemoLayout from "./base_demo/layout/DemoLayout";
import P1DemoLayout from "./p1_demo/layout/DemoLayout";
import P2DemoLayout from "./p2_demo/layout/DemoLayout";
import P3DemoLayout from "./p3_demo/layout/DemoLayout";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />

                <Route path="/msdemo" element={<MSDemoLayout />} />
                <Route path="/basedemo" element={<BaseDemoLayout />} />
                <Route path="/p1demo" element={<P1DemoLayout />} />
                <Route path="/p2demo" element={<P2DemoLayout />} />
                <Route path="/p3demo" element={<P3DemoLayout />} />
            </Routes>
        </Router>
    );
}

export default App;
